import produce from 'immer';
import { handleActions } from 'redux-actions';
import actions from './actions';
import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../app/models';
import {
  ORDER_ALL_LIST_FILTER_OPTION_MODEL,
  ORDER_ALL_LIST_SEARCH_DATA_MODEL,
  ORDER_ALL_LIST_SEARCH_OPTION_MODEL,
  ORDER_ALL_LIST_SORT_OPTION_MODEL,
  ORDER_BALANCE_INFO_MODEL,
  ORDER_CANCEL_LIST_FILTER_OPTION_MODEL,
  ORDER_CANCEL_LIST_SEARCH_DATA_MODEL,
  ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL,
  ORDER_CANCEL_LIST_SORT_OPTION_MODEL,
  ORDER_CANCEL_SUMMARY_BOX_MODEL,
  ORDER_EXCHANGE_HISTORY_MODEL,
  ORDER_EXCHANGE_LIST_FILTER_OPTION_MODEL,
  ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL,
  ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL,
  ORDER_EXCHANGE_LIST_SORT_OPTION_MODEL,
  ORDER_EXCHANGE_SUMMARY_BOX_MODEL,
  ORDER_INFO_MODEL,
  ORDER_RETURN_DETAIL_MODEL,
  ORDER_RETURN_HISTORY_MODEL,
  ORDER_RETURN_LIST_FILTER_OPTION_MODEL,
  ORDER_RETURN_LIST_SEARCH_DATA_MODEL,
  ORDER_RETURN_LIST_SEARCH_OPTION_MODEL,
  ORDER_RETURN_LIST_SORT_OPTION_MODEL,
  ORDER_RETURN_SUMMARY_BOX_MODEL,
  ORDER_REVIEW_INFO_MODEL,
  ORDER_SUMMARY_BOX_MODEL,
  ORDER_MANAGEMENT_LIST_MODEL,
  ORDER_CANCEL_MANAGEMENT_MODEL,
  ORDER_RETURN_MANAGEMENT_MODEL,
  ORDER_EXCHANGE_MANAGEMENT_MODEL,
} from './models';
import {
  ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL,
} from '../account/user/models';
import { CS_INQUIRY_LIST_SORT_OPTION_MODEL } from '../cs/inquiry/models';
import { CS_QNA_LIST_SORT_OPTION_MODEL } from '../cs/qna/models';
import {
  ORDER_RETURN_STATUS,
  ORDER_ITEM_STATUS,
  ORDER_CANCEL_ITEM_STATUS,
  ORDER_PROCESS_MANAGER_TYPE,
  ORDER_EXCHANGE_STATUS,
  ORDER_TYPE,
  ORDER_GIFT_STATUS,
} from '../../../constants/service/app/orderConstants';
import { addAllItemToSelectList, updateStoreWithPath } from '../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  상품 1차 카테고리 리스트
   */
  mainProductCategorySelectList: [],

  /**
   *  주문 전체 리스트
   */
  orderAllList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  주문 집계
     */
    orderSummaryBox: ORDER_SUMMARY_BOX_MODEL,
    /**
     *  검색 박스
     */
    searchData: ORDER_ALL_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_ALL_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_ALL_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: ORDER_ALL_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  주문 취소 리스트
   */
  orderCancelList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  주문 취소 집계
     */
    orderCancelSummaryBox: ORDER_CANCEL_SUMMARY_BOX_MODEL,
    /**
     *  검색 박스
     */
    searchData: ORDER_CANCEL_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_CANCEL_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: ORDER_CANCEL_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  주문 반품 리스트
   */
  orderReturnList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  주문 반품 집계
     */
    orderReturnSummaryBox: ORDER_RETURN_SUMMARY_BOX_MODEL,
    /**
     *  검색 박스
     */
    searchData: ORDER_RETURN_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_RETURN_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_RETURN_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: ORDER_RETURN_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  주문 교환 리스트
   */
  orderExchangeList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  주문 교환 집계
     */
    orderExchangeSummaryBox: ORDER_EXCHANGE_SUMMARY_BOX_MODEL,
    /**
     *  검색 박스
     */
    searchData: ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: ORDER_EXCHANGE_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: ORDER_EXCHANGE_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  주문/배송관리 리스트
   */
  orderManagementList: ORDER_MANAGEMENT_LIST_MODEL,

  /**
   *  취소 관리
   */
  orderCancelManagement: ORDER_CANCEL_MANAGEMENT_MODEL,

  /**
   *  반품 관리
   */
  orderReturnManagement: ORDER_RETURN_MANAGEMENT_MODEL,

  /**
   *  교환 관리
   */
  orderExchangeManagement: ORDER_EXCHANGE_MANAGEMENT_MODEL,

  /**
   *  주문 상세
   */
  orderDetail: {
    /**
     *  주문 정보
     */
    orderInfo: ORDER_INFO_MODEL,
    /**
     *  취소 이력
     */
    cancelHistory: [],
    /**
     *  반품 이력
     */
    returnHistory: ORDER_RETURN_HISTORY_MODEL,
    /**
     *  교환 이력
     */
    exchangeHistory: ORDER_EXCHANGE_HISTORY_MODEL,
    /**
     *  후기 내역
     */
    reviewInfo: ORDER_REVIEW_INFO_MODEL,
    /**
     *  정산 내역
     */
    balanceInfo: ORDER_BALANCE_INFO_MODEL,
    /**
     *  1:1 문의 내역
     */
    inquiryInfo: {
      /**
       *  리스트
       */
      list: [],
      /**
       *  검색 옵션
       */
      filterOption: ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션 리스트
       */
      sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
      /**
       *  리스트 pagination
       */
      pagination: LIST_PAGINATION_MODEL,
      /**
       *  집계 데이터
       */
      summary: LIST_SUMMARY_MODEL,
    },
    /**
     *  상품 문의 내역
     */
    qnaInfo: {
      /**
       *  리스트
       */
      list: [],
      /**
       *  검색 옵션
       */
      filterOption: ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션 리스트
       */
      sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
      /**
       *  리스트 pagination
       */
      pagination: LIST_PAGINATION_MODEL,
      /**
       *  집계 데이터
       */
      summary: LIST_SUMMARY_MODEL,
    },
    /**
     *  정산 예정 금액
     */
    finalBalance: 0,
    /**
     *  정산 집행 금액
     */
    paidBalance: 0,
    /**
     *  정산 보류 금액
     */
    holdBalance: 0,
    /**
     *  정산 추가 금액
     */
    extraBalance: 0,
  },

  /**
   *  주문 반품 상세
   */
  orderReturnDetail: ORDER_RETURN_DETAIL_MODEL,

  /**
   *  주문 상태 되돌리기 모달
   */
  orderItemStatusChangeModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  발송 처리 유효성 체크 결과 모달
   */
  checkDeliveryDispatchResultModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  배송 지연처리 모달
   */
  deliveryDelayModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  엑셀 일괄 발송 처리 유효성 체크 결과 모달
   */
  checkExcelBulkDeliveryDispatchResultModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  엑셀 일괄발송 모달
   */
  excelBulkDeliveryDispatchModal: {
    isOpen: false,
  },

  /**
   *  판매 취소 모달
   */
  cancelSalesModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  재고/상품상태 설정 모달
   */
  cancelSalesConfirmModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  주문자 정보 수정 모달
   */
  editBuyerInfoModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  취소 거부 모달
   */
  rejectCancelModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  취소 완료전 설정하는 재고/상품상태 설정 모달
   */
  cancelCompleteConfirmModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  취소 거부 -> 발송 처리 모달
   */
  rejectCancelDeliveryDispatchModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  반품 거부 모달
   */
  rejectReturnModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  반품 사유 수정 모달
   */
  editReasonReturnModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  반품 승인 모달
   */
  completeReturnModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  반품 요청, 거부 사유 모달
   */
  returnReasonModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  교환 거부 모달
   */
  rejectExchangeModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  교환 사유 수정 모달
   */
  editExchangeReasonModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  교환 재배송 송장 수정 모달
   */
  editExchangeDeliveryInfoModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  교환 완료 모달
   */
  completeExchangeModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  교환 요청, 거부 사유 모달
   */
  exchangeReasonModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  교환/반품 요청하기 모달
   */
  orderItemReturnExchangeRequestModal: {
    isOpen: false,
    data: {},
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [주문] 주문 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [주문 전체 리스트] 주문 전체 리스트 받아오기
     */
    [actions.GET_ORDER_ALL_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 전체 리스트
         */
        draft.orderAllList = {
          ...draft.orderAllList,
          ...action.payload.orderAllList,
          orderSummaryBox: action.payload.orderSummaryBox,
        };
      });
    },

    /**
     *  [주문 취소 리스트] 주문 취소 리스트 받아오기
     */
    [actions.GET_ORDER_CANCEL_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 취소 리스트
         */
        draft.orderCancelList = {
          ...draft.orderCancelList,
          ...action.payload.orderCancelList,
          orderCancelSummaryBox: action.payload.orderCancelSummaryBox,
        };
      });
    },

    /**
     *  [주문 반품 리스트] 주문 반품 리스트 받아오기
     */
    [actions.GET_ORDER_RETURN_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 반품 리스트
         */
        draft.orderReturnList = {
          ...draft.orderReturnList,
          ...action.payload.orderReturnList,
          orderReturnSummaryBox: action.payload.orderReturnSummaryBox,
        };
      });
    },

    /**
     *  [주문 교환 리스트] 주문 교환 리스트 받아오기
     */
    [actions.GET_ORDER_EXCHANGE_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 교환 리스트
         */
        draft.orderExchangeList = {
          ...draft.orderExchangeList,
          ...action.payload.orderExchangeList,
          orderExchangeSummaryBox: action.payload.orderExchangeSummaryBox,
        };
      });
    },

    /**
     *  [주문/배송관리] 주문/배송관리 리스트 요청하기
     */
    [actions.GET_ORDER_MANAGEMENT_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문/배송관리 리스트
         */
        draft.orderManagementList = {
          ...draft.orderManagementList,
          ...action.payload,
          deliveryAgentList: addAllItemToSelectList(action.payload.deliveryAgentList, '택배사 선택'),
          /**
           *  선택된 상품 주문 리스트 초기화
           */
          selectedOrderItemList: [],
        };
      });
    },

    /**
     *  [주문/배송관리] 상품 주문 상품 준비 처리하기
     */
    [actions.DELIVERY_PREPARATION_ORDER_MANAGEMENT_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 리스트 업데이트
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          /**
           *  해당 상품 주문 index
           */
          const updateIndex = draft.orderManagementList.list.findIndex((orderItem) => orderItem.id === orderItemId);
          if (draft.orderManagementList.list[updateIndex]) {
            draft.orderManagementList.list[updateIndex] = {
              ...draft.orderManagementList.list[updateIndex],
              orderItemStatus: ORDER_ITEM_STATUS.DELIVERY_PREPARATION,
              deliveryPrepareDate: action.payload.deliveryPrepareDate,
            };
          }
        });
      });
    },

    /**
     *  [주문/배송관리] 상품 주문 배송 지연처리하기
     */
    [actions.DELIVERY_DELAY_ORDER_MANAGEMENT_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 리스트 업데이트
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          /**
           *  해당 상품 주문 index
           */
          const updateIndex = draft.orderManagementList.list.findIndex((orderItem) => orderItem.id === orderItemId);
          if (draft.orderManagementList.list[updateIndex]) {
            draft.orderManagementList.list[updateIndex] = {
              ...draft.orderManagementList.list[updateIndex],
              orderItemStatus: ORDER_ITEM_STATUS.SHIPPING_DELAY,
            };
          }
        });
      });
    },

    /**
     *  [주문/배송관리] 상품 주문 발송 처리하기
     */
    [actions.DELIVERY_DISPATCH_ORDER_MANAGEMENT_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 리스트 업데이트
         */
        action.payload.orderItemList.forEach((item) => {
          /**
           *  해당 상품 주문 index
           */
          const updateIndex = draft.orderManagementList.list.findIndex((orderItem) => orderItem.id === item.id);
          if (draft.orderManagementList.list[updateIndex]) {
            draft.orderManagementList.list[updateIndex] = {
              ...draft.orderManagementList.list[updateIndex],
              ...item,
            };
          }
        });
      });
    },

    /**
     *  [주문/배송관리] 판매 취소하기
     */
    [actions.CANCEL_SALES_ORDER_MANAGEMENT_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        const { orderItemIdList = [] } = action.payload;
        draft.orderManagementList.list = draft.orderManagementList.list.map((orderItem) => ({
          ...orderItem,
          orderItemStatus: orderItemIdList.includes(orderItem.id)
            ? ORDER_ITEM_STATUS.CANCELLATION
            : orderItem.orderItemStatus,
        }));
        /**
         *  선택된 상품 주문서 리스트 초기화
         */
        draft.orderManagementList.selectedOrderItemList = [];
        /**
         *  재고/상품상태 설정 모달 off
         */
        draft.cancelSalesConfirmModal.isOpen = false;
      });
    },

    /**
     *  [주문/배송관리] 주문자 정보 수정하기
     */
    [actions.EDIT_BUYER_INFO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        const { targetOrderItem, orderItemModifyId, giftStatusUpdateOrderId } = action.payload;

        /**
         *  해당 상품 주문 index
         */
        const indexList = [];

        /**
         *  선물 수락 대기 상태인 상품 주문건의
         *  주문자 정보 수정을 하는 경우
         */
        if (giftStatusUpdateOrderId) {
          const targetIndexList = draft.orderManagementList.list.reduce((acc, orderItem, index) => {
            if (orderItem.orderId === giftStatusUpdateOrderId) acc.push(index);
            return acc;
          }, []);
          indexList.push(...targetIndexList);
        } else {
          /**
           *  선물 수락 대기 외에
           *  주문자 정보 수정을 하는 경우
           */
          const targetIndex = draft.orderManagementList.list.findIndex(
            (orderItem) => orderItem.id === targetOrderItem.orderItemId,
          );
          indexList.push(targetIndex);
        }

        indexList.forEach((targetIndex) => {
          const targetItem = draft.orderManagementList.list[targetIndex];

          draft.orderManagementList.list[targetIndex] = {
            ...targetItem,
            giftStatus:
              targetItem.orderId === giftStatusUpdateOrderId && targetItem.orderType === ORDER_TYPE.GIFT
                ? ORDER_GIFT_STATUS.ACCEPT
                : targetItem.giftStatus,
            orderItemModifyId: orderItemModifyId || targetItem.orderItemModifyId,
            recipientName: targetOrderItem.recipientName,
            recipientPhone: targetOrderItem.recipientPhone,
            shippingAddress1: targetOrderItem.shippingAddress.line1,
            shippingAddress2: targetOrderItem.shippingAddress.line2,
            shippingPostCode: targetOrderItem.shippingAddress.postCode,
            shippingMessage: targetOrderItem.shippingMessage,
          };
        });
      });
    },

    /**
     *  [취소 관리] 취소 관리 리스트 요청하기
     */
    [actions.GET_ORDER_CANCEL_MANAGEMENT_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  취소 관리
         */
        draft.orderCancelManagement.orderCancelManagementList = {
          ...draft.orderCancelManagement.orderCancelManagementList,
          ...action.payload.orderCancelManagementList,
        };

        /**
         *  select list 초기화
         */
        draft.orderCancelManagement.orderCancelManagementSelectedList = [];
      });
    },

    /**
     *  [취소 관리] 취소 거부 요청하기
     */
    [actions.REJECT_ORDER_CANCEL_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 취소 리스트 업데이트
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          /**
           *  해당 상품 index
           */
          const targetIndex = draft.orderCancelManagement.orderCancelManagementList.list.findIndex(
            (orderItem) => orderItem.id === orderItemId,
          );
          draft.orderCancelManagement.orderCancelManagementList.list[targetIndex] = {
            ...draft.orderCancelManagement.orderCancelManagementList.list[targetIndex],
            /**
             *  취소 주문 상태
             */
            orderItemCancelStatus: ORDER_CANCEL_ITEM_STATUS.CANCEL_REJECT,
            /**
             *  취소 거부 일시
             */
            rejectDate: action.payload.rejectDate,
            /**
             *  취소 거부 사유
             */
            rejectReason: action.payload.rejectReason,
          };
        });
        /**
         *  선택된 상품 주문서 리스트 초기화
         */
        draft.orderCancelManagement.orderCancelManagementSelectedList = [];
      });
    },

    /**
     *  [취소 관리] 취소 완료 요청하기
     */
    [actions.COMPLETE_ORDER_CANCEL_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 취소 리스트 업데이트
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          /**
           *  해당 상품 index
           */
          const index = draft.orderCancelManagement.orderCancelManagementList.list.findIndex(
            (orderItem) => orderItem.id === orderItemId,
          );
          draft.orderCancelManagement.orderCancelManagementList.list[index] = {
            ...draft.orderCancelManagement.orderCancelManagementList.list[index],
            /**
             *  취소 거부 상태
             */
            orderItemCancelStatus: ORDER_CANCEL_ITEM_STATUS.REFUND_DONE,
            /**
             *  취소 처리자
             */
            cancelManager: ORDER_PROCESS_MANAGER_TYPE.SELLER,
            /**
             *  취소 완료 일시
             */
            cancelCompleteDate: action.payload.cancelCompleteDataList[`${orderItemId}`].cancelCompleteDate,
            /**
             *  실제 고객 환불 금액
             */
            refundActualAmount: action.payload.cancelCompleteDataList[`${orderItemId}`].cancelAmount,
          };
        });
        /**
         *  선택된 상품 주문서 리스트 초기화
         */
        draft.orderCancelManagement.orderCancelManagementSelectedList = [];
        /**
         *  재고/상품상태 설정 모달 off
         */
        draft.cancelCompleteConfirmModal.isOpen = false;
      });
    },

    /**
     *  [취소 관리] 취소 거부 -> 발송 처리하기
     */
    [actions.DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_SUCCESS]: (state, action) => {
      /**
       *  [취소 관리] 취소 거부 -> 발송 처리하기
       */
      return produce(state, (draft) => {
        /**
         *  상품 주문 취소 리스트 업데이트
         */
        draft.orderCancelManagement.orderCancelManagementList.list =
          draft.orderCancelManagement.orderCancelManagementList.list.filter(
            (item) => action.payload.orderItemId !== item.orderItemId,
          );
        /**
         *  취소 관리 페이지에서 총 조회 갯수에서 1을 빼야한다. (한번에 한건만 가능)
         */
        draft.orderCancelManagement.orderCancelManagementList.pagination.totalCnt -= 1;
        /**
         *  선택된 상품 주문서 리스트 초기화
         */
        draft.orderCancelManagement.orderCancelManagementSelectedList = [];
      });
    },

    /**
     *  [반품 관리] 반품 관리 리스트 요청하기
     */
    [actions.GET_ORDER_RETURN_MANAGEMENT_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  반품 관리
         */
        draft.orderReturnManagement.orderReturnManagementList = {
          ...draft.orderReturnManagement.orderReturnManagementList,
          ...action.payload.orderReturnManagementList,
        };

        /**
         *  select list 초기화
         */
        draft.orderReturnManagement.orderReturnManagementSelectedList = [];
      });
    },

    /**
     *  [반품 관리] 반품 수거 완료 요청하기
     */
    [actions.COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  반품 관리
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          /**
           *  해당 상품 주문 아이템 index
           */
          const targetIndex = draft.orderReturnManagement.orderReturnManagementList.list.findIndex(
            (item) => item.id === orderItemId,
          );
          draft.orderReturnManagement.orderReturnManagementList.list[targetIndex] = {
            ...draft.orderReturnManagement.orderReturnManagementList.list[targetIndex],
            orderItemReturnStatus: ORDER_RETURN_STATUS.PICK_UP_DONE,
            receiveDate: action.payload.receiveDate,
          };
        });
      });
    },

    /**
     *  [반품 관리] 반품 사유 수정 요청하기
     */
    [actions.EDIT_ORDER_RETURN_ITEM_REASON_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  반품 관리
         */
        action.payload.orderItemList.forEach((item) => {
          /**
           *  해당 상품 주문 아이템 index
           */
          const targetIndex = draft.orderReturnManagement.orderReturnManagementList.list.findIndex(
            (orderItem) => orderItem.id === item.orderItemId,
          );
          draft.orderReturnManagement.orderReturnManagementList.list[targetIndex] = {
            ...draft.orderReturnManagement.orderReturnManagementList.list[targetIndex],
            returnReasonModifyDate: action.payload.returnReasonModifyDate,
            returnType: action.payload.returnType,
            returnReason: action.payload.returnReason,
            returnDeliveryFee: item.returnDeliveryFee,
            refundExpectAmount: item.refundExpectAmount,
          };
        });
      });
    },

    /**
     *  [반품 관리] 반품 -> 교환 요청하기
     */
    [actions.CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  반품 관리 리스트 업데이트
         */
        draft.orderReturnManagement.orderReturnManagementList.list =
          draft.orderReturnManagement.orderReturnManagementList.list.filter(
            (item) => action.payload.orderItemId !== item.id,
          );
        /**
         *  반품 관리 페이지에서 총 조회 갯수에서 1을 빼야한다. (한번에 한건만 가능)
         */
        draft.orderReturnManagement.orderReturnManagementList.pagination.totalCnt -= 1;
        /**
         *  선택된 상품 주문서 리스트 초기화
         */
        draft.orderReturnManagement.orderReturnManagementSelectedList = [];
      });
    },

    /**
     *  [반품 관리] 반품 거부 요청하기
     */
    [actions.REJECT_ORDER_RETURN_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  해당 상품 주문 아이템 index
         */
        const targetIndex = draft.orderReturnManagement.orderReturnManagementList.list.findIndex(
          (orderItem) => orderItem.id === action.payload.orderItemId,
        );
        draft.orderReturnManagement.orderReturnManagementList.list[targetIndex] = {
          ...draft.orderReturnManagement.orderReturnManagementList.list[targetIndex],
          orderItemReturnStatus: ORDER_RETURN_STATUS.REJECT,
          rejectDate: action.payload.rejectDate,
          returnRejectReason: action.payload.returnRejectReason,
        };
      });
    },

    /**
     *  [반품 관리] 반품 승인 요청하기
     */
    [actions.COMPLETE_ORDER_RETURN_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  해당 상품 주문 아이템 index
         */
        const targetIndex = draft.orderReturnManagement.orderReturnManagementList.list.findIndex(
          (orderItem) => orderItem.id === action.payload.orderItemId,
        );
        draft.orderReturnManagement.orderReturnManagementList.list[targetIndex] = {
          ...draft.orderReturnManagement.orderReturnManagementList.list[targetIndex],
          orderItemReturnStatus: ORDER_RETURN_STATUS.RETURN_DONE,
          returnCompleteDate: action.payload.returnCompleteDate,
          refundSellerAmount: action.payload.refundSellerAmount,
        };
      });
    },

    /**
     *  [교환 관리] 교환 관리 리스트 요청하기
     */
    [actions.GET_ORDER_EXCHANGE_MANAGEMENT_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  교환 관리
         */
        draft.orderExchangeManagement.orderExchangeManagementList = {
          ...draft.orderExchangeManagement.orderExchangeManagementList,
          ...action.payload.orderExchangeManagementList,
        };

        /**
         *  select list 초기화
         */
        draft.orderExchangeManagement.orderExchangeManagementSelectedList = [];
      });
    },

    /**
     *  [교환 관리] 교환 수거 완료 요청하기
     */
    [actions.COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 교환 리스트 업데이트
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          const targetIndex = draft.orderExchangeManagement.orderExchangeManagementList.list.findIndex(
            (orderItem) => orderItem.id === orderItemId,
          );
          draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex] = {
            ...draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex],
            orderItemExchangeStatus: ORDER_EXCHANGE_STATUS.PICK_UP_DONE,
            receiveDate: action.payload.receiveDate,
          };
        });
      });
    },

    /**
     *  [교환 관리] 교환 거부 요청하기
     */
    [actions.REJECT_ORDER_EXCHANGE_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 교환 리스트 업데이트
         *  해당 상품 index
         */
        const targetIndex = draft.orderExchangeManagement.orderExchangeManagementList.list.findIndex(
          (orderItem) => orderItem.id === action.payload.orderItemId,
        );
        draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex] = {
          ...draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex],
          orderItemExchangeStatus: ORDER_EXCHANGE_STATUS.REJECT,
          rejectDate: action.payload.rejectDate,
          rejectReason: action.payload.rejectReason,
        };
      });
    },

    /**
     *  [교환 관리] 교환 사유 수정 요청하기
     */
    [actions.EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  교환 관리
         */
        action.payload.orderItemIdList.forEach((orderItemId) => {
          /**
           *  해당 상품 주문 아이템 index
           */
          const targetIndex = draft.orderExchangeManagement.orderExchangeManagementList.list.findIndex(
            (orderItem) => orderItem.id === orderItemId,
          );
          draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex] = {
            ...draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex],
            exchangeReasonModifyDate: action.payload.exchangeReasonModifyDate,
            exchangeType: action.payload.exchangeType,
            exchangeReason: action.payload.exchangeReason,
          };
        });
      });
    },

    /**
     *  [교환 관리] 교환 재배송 송장 수정 요청하기
     */
    [actions.EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 교환 리스트 업데이트
         */
        action.payload.orderItemList.forEach((item) => {
          /**
           *  해당 상품 주문 아이템 index
           */
          const targetIndex = draft.orderExchangeManagement.orderExchangeManagementList.list.findIndex(
            (orderItem) => orderItem.id === item.orderItemId,
          );
          draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex] = {
            ...draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex],
            /**
             *  교환 처리 상태
             */
            orderItemExchangeStatus: item.orderItemExchangeStatus,
            /**
             *  교환품 배송 처리 일시
             */
            exchangeDispatchDate: item.exchangeDispatchDate,
            /**
             *  교환 완료 일시
             */
            exchangeCompleteDate: item.exchangeCompleteDate,
            /**
             *  교환 배송 방법
             */
            exchangeDeliveryType: action.payload.exchangeDeliveryType,
            /**
             *  교환 배송 deliveryId
             */
            exchangeDeliveryId: item.exchangeDeliveryId,
            /**
             *  교환 배송 택배사
             */
            exchangeDeliveryAgentName: item.exchangeDeliveryAgentName,
            /**
             *  교환 배송 송장번호
             */
            exchangeInvoiceNumber: action.payload.exchangeInvoiceNumber,
          };
        });
      });
    },

    /**
     *  [교환 관리] 교환 승인 요청하기
     */
    [actions.COMPLETE_ORDER_EXCHANGE_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 주문 교환 리스트 업데이트
         *  해당 상품 index
         */
        const targetIndex = draft.orderExchangeManagement.orderExchangeManagementList.list.findIndex(
          (orderItem) => orderItem.id === action.payload.orderItemId,
        );
        draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex] = {
          ...draft.orderExchangeManagement.orderExchangeManagementList.list[targetIndex],
          /**
           *  교환 처리 상태
           */
          orderItemExchangeStatus: action.payload.orderItemExchangeStatus,
          /**
           *  교환품 배송 처리 일시
           */
          exchangeDispatchDate: action.payload.exchangeDispatchDate,
          /**
           *  교환 완료 일시
           */
          exchangeCompleteDate: action.payload.exchangeCompleteDate,
          /**
           *  교환 배송 방법
           */
          exchangeDeliveryType: action.payload.exchangeDeliveryType,
          /**
           *  교환 배송 deliveryId
           */
          exchangeDeliveryId: action.payload.exchangeDeliveryId,
          /**
           *  교환 배송 택배사
           */
          exchangeDeliveryAgentName: action.payload.exchangeDeliveryAgentName,
          /**
           *  교환 배송 송장번호
           */
          exchangeInvoiceNumber: action.payload.exchangeInvoiceNumber,
          /**
           *  구매자 연락처
           */
          exchangeBuyerPhone: action.payload.exchangeBuyerPhone,
          /**
           *  수취인 연락처
           */
          exchangeRecipientPhone: action.payload.exchangeRecipientPhone,
          /**
           *  배송지
           */
          exchangeShippingAddress: action.payload.exchangeShippingAddress,
          /**
           *  우편번호
           */
          exchangeShippingPostCode: action.payload.exchangeShippingPostCode,
          /**
           *  배송메시지
           */
          exchangeShippingMessage: action.payload.exchangeShippingMessage,
        };
      });
    },

    /**
     *  [교환 관리] 교환 -> 반품 요청하기
     */
    [actions.CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  교환 관리 리스트 업데이트
         */
        draft.orderExchangeManagement.orderExchangeManagementList.list =
          draft.orderExchangeManagement.orderExchangeManagementList.list.filter(
            (item) => action.payload.orderItemId !== item.id,
          );
        /**
         *  반품 관리 페이지에서 총 조회 갯수에서 1을 빼야한다. (한번에 한건만 가능)
         */
        draft.orderExchangeManagement.orderExchangeManagementList.pagination.totalCnt -= 1;
        /**
         *  선택된 상품 주문서 리스트 초기화
         */
        draft.orderExchangeManagement.orderExchangeManagementSelectedList = [];
      });
    },

    /**
     *  [주문 상세] 주문 상세 받아오기
     */
    [actions.GET_ORDER_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 상세
         */
        draft.orderDetail = action.payload.orderDetail;
      });
    },

    /**
     *  [주문 반품 상세] 주문 반품 상세 받아오기
     */
    [actions.GET_ORDER_RETURN_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 반품 상세
         */
        draft.orderReturnDetail = action.payload.orderReturnDetail;

        /**
         *  반품 완료인 상세 데이터를 보여줄때는
         *  바로 DB에 있는 값을 보여준다.
         *  반품 승인인 상세 데이터일 경우에는 계산해서 값을 보여주도록한다.
         */
        if (action.payload.orderReturnDetail.orderReturnStatus !== ORDER_RETURN_STATUS.REFUND_DONE) {
          /**
           *  최종 환불 금액
           */
          draft.orderReturnDetail.refundActualAmount = action.payload.orderReturnDetail.refundSellerAmount;

          /**
           * 판매자가 정산받을 금액
           * 고객 결제 금액 + 고객 부담 추가 배송비 - 최종 환불 금액
           */
          draft.orderReturnDetail.sellerExpectBalanceAmount =
            action.payload.orderReturnDetail.totalPrice +
            action.payload.orderReturnDetail.buyerDeliveryExtraFee -
            action.payload.orderReturnDetail.refundSellerAmount;
        }
      });
    },

    /**
     *  [주문상세] 교환 요청하기
     */
    [actions.SUBMIT_ORDER_EXCHANGE_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  주문 상세 정보
         */
        draft.orderDetail = {
          ...draft.orderDetail,
          /**
           * 주문 정보 탭
           */
          orderInfo: {
            ...draft.orderDetail.orderInfo,
            ...action.payload.orderDetail.orderInfo,
          },
          /**
           *  교환 이력 탭
           */
          exchangeHistory: {
            ...draft.orderDetail.exchangeHistory,
            ...action.payload.orderDetail.exchangeHistory,
          },
        };

        /**
         *  교환/반품으로 변경 모달 off
         */
        draft.orderItemReturnExchangeRequestModal.isOpen = false;
      });
    },

    /**
     *  [주문상세] 반품 요청하기
     */
    [actions.SUBMIT_ORDER_RETURN_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.orderDetail = {
          ...draft.orderDetail,
          /**
           * 주문 정보 탭
           */
          orderInfo: {
            ...draft.orderDetail.orderInfo,
            ...action.payload.orderDetail.orderInfo,
          },
          /**
           *  반품 이력 탭
           */
          returnHistory: {
            ...draft.orderDetail.returnHistory,
            ...action.payload.orderDetail.returnHistory,
          },
        };

        /**
         *  교환/반품으로 변경 모달 off
         */
        draft.orderItemReturnExchangeRequestModal.isOpen = false;
      });
    },

    /**
     *  [주문상세] cs 메모 등록 요청하기
     */
    [actions.INSERT_ORDER_ITEM_CS_MEMO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.orderDetail.orderInfo.orderItemCsList = action.payload.orderItemCsList;
      });
    },

    /**
     *  [주문상세] cs 메모 업데이트 요청하기
     */
    [actions.EDIT_ORDER_ITEM_CS_MEMO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.orderDetail.orderInfo.orderItemCsList = action.payload.orderItemCsList;
      });
    },

    /**
     *  [주문상세] 1:1 문의 리스트 요청하기
     */
    [actions.GET_ORDER_ITEM_CS_INQUIRY_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.orderDetail.inquiryInfo = action.payload.inquiryInfo;
      });
    },

    /**
     *  [주문상세] 상품 문의 리스트 요청하기
     */
    [actions.GET_ORDER_ITEM_CS_QNA_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.orderDetail.qnaInfo = action.payload.qnaInfo;
      });
    },

    /**
     *  모달 토글
     */
    [actions.TOGGLE_MODAL]: (state, action) => {
      return produce(state, (draft) => {
        if (action.payload.data) {
          updateStoreWithPath([action.payload.name, 'data'], action.payload.data, draft);
        }

        updateStoreWithPath([action.payload.name, 'isOpen'], !state[action.payload.name].isOpen, draft);
      });
    },

    [actions.RESET_ORDER_ALL_LIST]: (state) => {
      return produce(state, (draft) => {
        draft.orderAllList = initialState.orderAllList;
      });
    },
  },
  initialState,
);
